import { useMemo, useState } from "react";
import { updateFilters, updateList } from "@/mocks/resources";
import SectionHeading from "@/pages/home/components/SectionHeading";

const typeStyle: Record<string, string> = {
  视频: "bg-primary-100 text-primary-800",
  写真: "bg-accent-100 text-accent-900",
  图片: "bg-secondary-100 text-secondary-900",
};

export default function Updates() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () => (active === "全部" ? updateList : updateList.filter((u) => u.type === active)),
    [active],
  );

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="最新收录"
          icon="ri-history-line"
          title="按更新时间浏览新增内容"
          desc="下方按更新时间倒序列出近期新增与修订的资源条目，每条包含类型、更新日期与具体变更说明，方便按时间顺序回看整理进度。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-6 md:gap-8">
          <div className="flex lg:flex-col gap-2 flex-wrap">
            {updateFilters.map((f) => (
              <button
                key={f}
                type="button"
                aria-pressed={active === f}
                onClick={() => setActive(f)}
                className={`px-4 py-2 rounded-md text-sm border text-left transition-colors cursor-pointer whitespace-nowrap ${
                  active === f
                    ? "bg-primary-500 border-primary-500 text-background-50 font-medium"
                    : "bg-background-50 border-background-300 text-foreground-700 hover:border-primary-300"
                }`}
              >
                {f === "全部" ? "全部更新" : `${f}更新`}
              </button>
            ))}
          </div>

          <ol className="relative border-l border-background-300 pl-5 space-y-4">
            {list.map((item, index) => (
              <li key={`${item.title}-${index}`} className="relative">
                <span className="absolute -left-[27px] top-2 w-3 h-3 rounded-full bg-accent-500 ring-4 ring-background-100"></span>
                <div className="p-4 rounded-lg bg-background-50 border border-background-200">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`text-[11px] px-2 py-0.5 rounded-full ${typeStyle[item.type]}`}>
                      {item.type}
                    </span>
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {item.title}
                    </h3>
                  </div>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600">{item.note}</p>
                  <span className="mt-2 inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-calendar-line"></i>
                    {item.date}
                  </span>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}